import {
  DEFAULT_ANNOTATIONS_DIMENSIONS,
  MARGIN_TOP_STROKE,
  type AnnotationsDimensions,
} from '../constants.js';

export const getTrackSeparatorOffset = (
  index: number,
  dimensions: AnnotationsDimensions = DEFAULT_ANNOTATIONS_DIMENSIONS,
) => index * dimensions.trackHeight + MARGIN_TOP_STROKE;
